import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowUpRight, Check, Mail, Play } from 'lucide-react'

import { Container } from '@/components/common/container'
import { Seo } from '@/components/common/seo'
import { Button } from '@/components/ui/button'
import { FadeIn } from '@/components/motion/fade-in'
import {
  acquireAssets,
  afternicListingUrl,
  askingPrice,
} from '@/features/acquire/acquire-content'

export const Route = createFileRoute('/acquire')({
  component: AcquireRoute,
})

function AcquireRoute() {
  return (
    <>
      <Seo
        title="Domain & Project for Sale"
        description="ultimatecheckers.com and the working checkers game running on it are for sale together. See what's included and make an inquiry through Afternic."
        path="/acquire"
      />

      <Container className="flex flex-col gap-10 py-10 sm:gap-12 sm:py-14">
        <FadeIn className="flex flex-col gap-3">
          <h1 className="text-display-md sm:text-display-lg text-foreground">
            This domain and project are for sale.
          </h1>
          <p className="text-muted-foreground max-w-xl text-lg">
            ultimatecheckers.com and the working checkers game you can play right now are being sold
            together, as-is.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} className="flex flex-col gap-4">
          <div className="flex items-baseline justify-between gap-4">
            <h2 className="text-foreground text-lg font-semibold">What&apos;s included</h2>
            <span className="text-brand text-xl font-bold">{askingPrice}</span>
          </div>
          <ul className="flex flex-col gap-4">
            {acquireAssets.map((asset) => (
              <li key={asset.title} className="flex gap-3">
                <Check className="text-brand mt-0.5 size-4 shrink-0" />
                <div className="flex flex-col gap-0.5">
                  <span className="text-foreground font-medium">{asset.title}</span>
                  <span className="text-muted-foreground text-sm leading-relaxed">
                    {asset.description}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </FadeIn>

        <FadeIn delay={0.15} className="flex flex-col gap-3 sm:flex-row">
          <Button asChild size="lg">
            <a href={afternicListingUrl} target="_blank" rel="noopener noreferrer">
              View listing on Afternic
              <ArrowUpRight className="size-4" />
            </a>
          </Button>
          <Button asChild size="lg" variant="outline">
            <a href="mailto:yannickbokolopro@gmail.com?subject=Inquiry%20about%20ultimatecheckers.com&body=Hi,%0D%0A%0D%0AI%27m%20interested%20in%20ultimatecheckers.com.%0D%0A%0D%0A">
              <Mail className="size-4" />
              Email inquiry
            </a>
          </Button>
          <Button asChild size="lg" variant="outline">
            <Link to={'/play' as never}>
              <Play className="size-4" />
              Try the game first
            </Link>
          </Button>
        </FadeIn>

        <FadeIn delay={0.2}>
          <p className="text-muted-foreground max-w-xl text-sm leading-relaxed">
            Inquiries and offers are handled securely through Afternic, GoDaddy&apos;s domain
            marketplace.
          </p>
        </FadeIn>
      </Container>
    </>
  )
}
